import { useCallback } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase-config';

const useUpdateAccordion = (companyId, selectedYear, setQuarters) => {
    const updateAccordion = useCallback(async (quarterKey, accordionId, updatedFields) => {
        const yearDocRef = doc(db, `companies/${companyId}/accordions/YearSelect/years/${selectedYear}`);

        const docSnapshot = await getDoc(yearDocRef);
        if (!docSnapshot.exists()) {
            console.error("Document does not exist");
            return;
        }

        const quartersData = docSnapshot.data();
        const quarterAccordions = quartersData[quarterKey];
        const accordionIndex = quarterAccordions.findIndex(acc => acc.timeStamp === accordionId);

        if (accordionIndex === -1) {
            console.error("Accordion not found");
            return;
        }

        const accordionToUpdate = quarterAccordions[accordionIndex];
        Object.keys(updatedFields).forEach(field => {
            accordionToUpdate[field] = updatedFields[field];
        });


        await updateDoc(yearDocRef, {
            [quarterKey]: quarterAccordions
        });

        
        setQuarters(prevQuarters => ({
            ...prevQuarters,
            [quarterKey]: quarterAccordions
        }));
    }, [companyId, selectedYear, setQuarters]);

    return updateAccordion;
};

export default useUpdateAccordion;
